const uniqueInspectionIDAction = (payload) => {
  return {
    type: "atual-unique-id",
    payload
  }
}
export default uniqueInspectionIDAction;